import {AddItemResponseStatus_Success_Section_PromotionInvalid} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {COLORS, Text} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const PromotionInvalidSection: FC<{
  promotionInvalid: AddItemResponseStatus_Success_Section_PromotionInvalid;
}> = ({promotionInvalid}) => {
  return (
    <Section>
      <Notification>
        <NotificationText color="Red" size="px12" weight="mediumBold">
          {promotionInvalid.message}
        </NotificationText>
      </Notification>
    </Section>
  );
};

const Section = styled.div`
  border-bottom: 1px solid ${COLORS.Grey3};
  padding-bottom: 20px;
  padding-inline: 20px;
`;

const Notification = styled.div`
  border-radius: 4px;
  background-color: rgba(255, 90, 90, 0.08);
  padding: 6px 8px;
  text-align: center;
`;

const NotificationText = styled(Text)`
  align-items: center;
  display: flex;
  justify-content: center;
`;
